import types from './types';

const initialState = {
	current: null,
	profile: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		/* Set search term  */
		case types.UPDATE_CURRENT_CHAT:
			return {
				...state,
				current: action.payload
			};
		default:
			return state;
	}
};

